import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import TextField from "../Reusable/TextInput";
import { createUserServiceValidationForm } from "../../utils/validationSchemas";
import NumberField from "../Reusable/NumberField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import PhoneNumberField from "../Reusable/PhoneNumberField";
const MerchantCreateUser = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createUserServiceValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <div className={tw`grid md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Username"}
          register={register("username")}
          errors={errors?.username}
        />
        <TextField
            label={"Full Name"}
            register={register("full_name")}
            errors={errors?.full_name}
          />
        <TextField
          label={"Email"}
          register={register("email")}
          errors={errors?.email}
        />
        {/* <NumberField
          setValue={setValue}
          clearErrors={clearErrors}
          label={"Mobile Number"}
          register={register("mobile_number")}
          errors={errors?.mobile_number}
        /> */}
        <PhoneNumberField
          control={control}
          label={"Mobile Number"}
          name={"mobile_number"}
          errors={errors?.mobile_number}
        />
        <TextField
          label={"Password"}
          type="password"
          register={register("password")}
          errors={errors?.password}
        />
        <TextField
          label={"Confirm Password"}
          type="password"
          register={register("confirm_password")}
          errors={errors?.password}
        />
        <div className={tw`w-full flex justify-center gap-x-2 items-center `}>
          <div className={tw`w-full`}>
            <ComboboxInput
              url={APIS.CREATE_BRANCH}
              queryKey={"branch"}
              register={register("branch")}
              errors={errors?.branch}
              name={"branch"}
              label={"Branch"}
              props={{
                is_active: true,
              }}
              setValue={setValue}
              placeholder={"Select Branch"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </div>
        </div>
      </div>
    </FormLayout>
  );
};

export default MerchantCreateUser;
